const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.au.forwood.one',
    USER_TOKEN_URL: 'https://h7p0thayqi.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'ap-southeast-2',
    URL: 'https://vhkfo7dp8l.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.au.forwood.one',
    COMPANY_MICROFRONTEND_URL: 'https://company.au.forwood.one',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.au.forwood.one'
  },
  configurationService: {
    URL: 'https://config.au.forwood.one',
    WEBSOCKET: 'wss://l2a5ttj1n4.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
